module.exports = __webpack_public_path__ + "media/images/logo-4bbf06d6d51096cfae3746d8c7cbb898.svg";